import React, { useCallback } from 'react';
import styled from 'styled-components';
import useStore from '~/store';

import NumericInput from '~/components/NumericInput';

const InputWrapper = styled.div`
  display: flex;
  flex-grow: 0;
`;

const ageSelector = (s) => s.age;
const setAgeSelector = (s) => s.setAge;

export default function AgePicker() {
  const age = useStore(ageSelector);
  const setAge = useStore(setAgeSelector);

  const handleChange = useCallback((value) => {
    setAge(value);
  }, []);

  return (
    <InputWrapper>
      <NumericInput value={age} onChange={handleChange} />
    </InputWrapper>
  );
}
